import gql from 'graphql-tag';

import {
    ADMIN_DELETE_CONTENTPAGE_START,
    ADMIN_DELETE_CONTENTPAGE_SUCCESS,
    ADMIN_DELETE_CONTENTPAGE_ERROR
} from '../../constants';

import history from '../../history';
import { toastr } from 'react-redux-toastr';



export function deleteContentPageDetails(id) {
    return async (dispatch, getState, { client }) => {
        dispatch({
            type: ADMIN_DELETE_CONTENTPAGE_START,
            data: id
        });
        try {

            const query = gql`
            query getContentPageDetails {
                getContentPageDetails{
                id
                metaTitle
                metaDescription
                pageUrl
                pageTitle
                content
                isEnable
                createdAt
                }
            }
            `;

            const mutation = gql`
                mutation deleteContentPage ($id: Int!) {
                    deleteContentPage (id: $id) {
                        status
                        errorMessage
                    }
                }
            `;

            const { data } = await client.mutate({
                mutation,
                variables: { id },
                refetchQueries: [{ query }]
            });

            if (data.deleteContentPage.status === "200") {
                dispatch({
                    type: ADMIN_DELETE_CONTENTPAGE_SUCCESS
                });
                toastr.success("Delete Content Page Details", "Deleted successfully!");
                history.push('/siteadmin/contentpage/manage');
            } else {
                toastr.error("Delete Content Page Details", data.deleteContentPage.errorMessage || "Deleted failed!");
            }

        } catch (error) {
            dispatch({
                type: ADMIN_DELETE_CONTENTPAGE_ERROR,
                payload: {
                    error
                }
            });
        }
    }
}

export function updateContentPageStatus(id, isEnable) {
    return async (dispatch, getState, { client }) => {
        try {

            const query = gql`
                query getContentPageDetails {
                    getContentPageDetails{
                    id
                    metaTitle
                    metaDescription
                    pageUrl
                    pageTitle
                    content
                    isEnable
                    createdAt
                    }
                }
                `;

            const mutation = gql`
                mutation updateContentPageStatus ($id: Int, $isEnable: Boolean) {
                    updateContentPageStatus(id: $id, isEnable: $isEnable){
                        status
                        errorMessage
                    }
                }
            `;

            const { data } = await client.mutate({
                mutation,
                variables: { id, isEnable },
                refetchQueries: [{ query }]
            });

            if (data?.updateContentPageStatus?.status === "200") {
                toastr.success("Success!", "Status has changed");
            } else {
                toastr.error("Failed!", data.updateContentPageStatus.errorMessage || "Failed to change  status");
            }

        } catch (error) {
            toastr.error("Failed!", "Failed to change  status");
        }
    }
}

